import './next.button.scss';

import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';

import ArrowForward from '@mui/icons-material/ArrowForward';

export const NextButton = (props: LoadingButtonProps) => {
  return (
    <LoadingButton
      variant="contained"
      disabled={props.disabled}
      sx={{
        marginLeft: '10px',
        height: 40,
        width: 40,
        borderRadius: '50%',
        minWidth: 0,
        padding: 0,
        backgroundColor: '#000',
        boxShadow: 'none',
        '&.Mui-disabled': {
          color: 'white',
        },
        '&:hover': {
          backgroundColor: '#000',
          boxShadow: 'none',
        },
      }}
      {...props}
    >
      <ArrowForward />
    </LoadingButton>
  );
};
